import { useState, useCallback } from 'react';
import { useAuthenticatedApi } from './useAuthenticatedApi';
import { apiEndpoints } from '../utils/api';

/**
 * Custom hook for fetching workspace data from the API
 * @returns {Object} Object containing workspace data, loading state, error state, and getWorkspaceById function
 */
const useWorkspace = () => {
  const authenticatedApi = useAuthenticatedApi();
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fetches a workspace by its ID
   * @param {string} workspaceId - ID of the workspace to fetch
   * @returns {Promise<Object|null>} Workspace object or null on error
   */
  const getWorkspaceById = useCallback(async (workspaceId) => {
    if (!workspaceId) {
      setError(new Error('Workspace ID is required'));
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await authenticatedApi.get(apiEndpoints.workspace(workspaceId));

      setWorkspace(data);
      setLoading(false);
      return data;
    } catch (err) {
      console.error('Error fetching workspace:', err);
      setError(err);
      setLoading(false);
      return null;
    }
  }, [authenticatedApi]);

  return {
    workspace,
    loading,
    error,
    getWorkspaceById,
  };
};

export default useWorkspace; 